module.exports = __webpack_public_path__ + "img/inspiration.9317db8.webp";